import get from "lodash/get";
export default state =>
  get(state, "category.childLinks", [])
    .slice(0, 10)
    .map(childLink => ({
      ...childLink,
      linkUrl: `${childLink.linkUrl}&ctaref=cat_header`
    }));
